import React, { useEffect, useState } from 'react';
import Header from 'thesis-and-dissertations/layouts/app/components/Header';
import Footer from 'thesis-and-dissertations/layouts/app/components/Footer';
import FormPassword from './FormPassword'
import ProfileImage from '../../assets/img/profile.jpg'

import { Link, useParams } from 'react-router-dom';
import Api from '../../helpers/api.js';
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError';
import form from '../ResearchType/form.json';
import { toast } from 'react-toastify';

const api = new Api();

const Profile = () => {
    const { type } = useParams()
    const [errors, setErrors] = useState();
    const [file, setFile] = useState();
    const [loading, setLoading] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [formData, setFormData] = useState({})

    useEffect(() => {
        fetchProfile()
    }, [])

    const fetchProfile = () => {
        setLoading({ ...loading, getProfile: true })
        api.getProfile()
            .then(response => {
                const data = response.data.data;
                setFormData({
                    users_firstname: data?.users_firstname,
                    users_lastname: data?.users_lastname,
                    phone_number: data?.detail?.user_details_phone,
                    is_email: data?.is_email,
                    is_phone: data?.is_phone,
                    photo_url_full: data?.detail?.user_details_photo,
                    email: data?.email,
                    tipe_peneliti_tesis: data?.detail?.tipe_peneliti_tesis,
                    instansi_tesis: data?.detail?.instansi_tesis,
                    divisi_tesis: data?.detail?.divisi_tesis,
                    institusi_tesis: data?.detail?.institusi_tesis,
                    departemen_tesis: data?.detail?.departemen_tesis,
                    jabatan_tesis: data?.detail?.jabatan_tesis,
                    perusahaan_tesis: data?.detail?.perusahaan_tesis,
                    divisi_tesis: data?.detail?.divisi_tesis,
                    jabatan_tesis: data?.detail?.jabatan_tesis,
                })

                setLoading({ ...loading, getProfile: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, getProfile: false })
                handleApiError(error)
            })
    }

    const handleInput = (e, name) => {
        if (e.target.value == 'on') {
            setFormData({ ...formData, [name]: e.target.checked })
            return
        }

        setFormData({ ...formData, [name]: e.target.value })
    }

    const onImageClick = () => {
        setErrors({ ...errors, file: null })
        document.getElementById('input-file-avatar')?.click()
    }

    const onChangeImage = async (e) => {
        setFile(e.target.files[0])
        if (!window.confirm('update foto profil sekarang?')) {
            return
        }

        setLoading({ ...loading, updateFoto: true })
        api.updateFotoProfile({ file: e.target.files[0], '_method': 'PATCH' })
            .then(response => {
                fetchProfile()
                setLoading({ ...loading, updateFoto: false })
                setErrors({})
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, updateFoto: false })
                handleApiError(error)
            })
    }

    const onSubmit = () => {
        setLoading({ ...loading, updateProfile: true })

        api.updateProfile(formData)
            .then(response => {
                setLoading({ ...loading, updateProfile: false })
                toast.success(response?.data?.meta?.message)
                fetchProfile()
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, updateProfile: false })
                toast.error(data?.meta?.message)
            })
    };

    const handleReset = () => {
        setFormData({
            ...formData,
            firstname: '',
            lastname: '',
            phone_number: '',
            is_email: '',
            is_phone: ''
        })
        setErrors({})
    }

    const handleShowModal = (e) => {
        setShowModal(e)
    }

    return (
        <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
            <Header button={true} />

            <div className='row px-15'>
                <div className='row pt-10'>
                    <div className='col-md-12 pb-10'>
                        <div className='card'>
                            <div className='col-md-3 px-5 pt-7'>
                                <Link to={'/content-search'} className='btn btn-sm'>
                                    <span className='btn-label-icon'>
                                        <i className='fa fa-arrow-left pe-3'></i>Kembali
                                    </span>
                                </Link>
                            </div>
                        </div>

                        <div className='card px-10 pt-6'>
                            <div className='card p-8 border'>
                                <div className='border-bottom pb-8'>
                                    <p className='fw-bold fs-4'>Profil Detil</p>
                                </div>

                                <div className='row my-10 py-8'>
                                    <div className='col-md-3 mt-2'>
                                        <label htmlFor="avatar">Avatar</label>
                                    </div>
                                    <div className='col-md-9 mt-2'>
                                        <img
                                            src={formData?.photo_url_full ? formData?.photo_url_full : ProfileImage}
                                            alt='Profile Image'
                                            width={135}
                                            height={140}
                                            onClick={onImageClick}
                                        />

                                        <label
                                            className='btn btn-icon btn-circle btn-primary w-25px h-25px'
                                            data-kt-image-input-action='change'
                                            data-bs-toggle='tooltip'
                                            aria-label='Ubah foto profil'
                                            data-bs-original-title='Ubah foto profil'
                                            data-kt-initialized='1'
                                            style={{ marginTop: '-130px', marginLeft: '-10px' }}
                                        >
                                            <i className='fa fa-pencil' id='icon-upload'></i>
                                            <input
                                                type="file"
                                                id='input-file-avatar'
                                                accept='image/jpeg, image/png, image/jpeg'
                                                name="profile_image"
                                                onChange={onChangeImage}
                                                style={{ display: 'none' }} />
                                        </label>

                                        <p className='mt-2'>Allowed file types: png, jpg, jpeg.</p>
                                        {errors?.file ? <p className='text-danger mt-1'>{errors?.file}</p> : null}
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-3 pt-10'>
                                            <label htmlFor="users_firstname">Nama Depan</label>
                                        </div>
                                        <div className='col-md-9 pt-10'>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='users_firstname'
                                                onChange={value => handleInput(value, 'users_firstname')}
                                                value={formData?.users_firstname} />
                                            {errors?.users_firstname ? <p className='text-danger mt-1'>{errors?.users_firstname}</p> : null}
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-3 pt-10'>
                                            <label htmlFor="users_lastname">Nama Belakang</label>
                                        </div>
                                        <div className='col-md-9 pt-10'>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='users_lastname'
                                                onChange={value => handleInput(value, 'users_lastname')}
                                                value={formData?.users_lastname} />
                                            {errors?.users_lastname ? <p className='text-danger mt-1'>{errors?.users_lastname}</p> : null}
                                        </div>
                                    </div>

                                    {form[formData?.tipe_peneliti_tesis]?.map((item, index) => {
                                        return (
                                            <div className='row' index={index}>
                                                <div className='col-md-3 pt-10'>
                                                    <label htmlFor={item?.text}>{item?.text}</label>
                                                </div>
                                                <div className='col-md-9 pt-10'>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name={item?.text}
                                                        onChange={value => handleInput(value, `${item?.name}`)}
                                                        value={formData?.[item?.name]} />
                                                    {errors?.[item?.name] ? <p className='text-danger mt-1'>{errors?.[item?.name]}</p> : null}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>


                                <div className='border-top'>
                                    <div className='pt-6 float-end'>
                                        <button type='button'
                                            onClick={handleReset}
                                            className='btn btn-secondary btn-sm rounded-pill mx-2'>Batal</button>
                                        <button type='button'
                                            onClick={() => onSubmit()}
                                            disabled={loading?.updateProfile}
                                            className='btn btn-primary btn-sm rounded-pill'>Simpan</button>
                                    </div>
                                </div>

                            </div>


                            <div className='card border my-12'>
                                <div className='card p-10'>
                                    <div className='border-bottom pb-8'>
                                        <p className='fw-bold fs-4'>Informasi Akun</p>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-8 mt-10'>
                                            <p className='fw-bold'>Email</p>
                                            <p>{formData?.email}</p>
                                        </div>

                                        <div className='col-md-8 mt-10'>
                                            <p className='fw-bold'>Password</p>
                                            <p>*****</p>
                                        </div>
                                        <div className='col-md-4 mt-10'>
                                            <button
                                                onClick={() => setShowModal(true)}
                                                className='btn btn-sm btn-secondary rounded-pill float-end'>Ubah Password</button>
                                        </div>

                                        <FormPassword showModal={showModal} handleShowModal={handleShowModal} />
                                    </div>

                                    {/* <div className='mt-10 p-8' style={{ borderStyle: 'dotted', backgroundColor: '#E9F3FF', borderColor: '#1B84FF', borderRadius: '10px' }}>
                                <div className='row' style={{ alignItems: 'center' }}>
                                    <div className='col-md-8'>
                                        <p className='fw-bold'>Secure Your Account</p>
                                        <p>Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <button className='btn btn-sm btn-secondary rounded-pill float-end'>Enable</button>
                                    </div>
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    );
};

export default Profile;